<template>
  <!-- 案件詳細 -->
  <div id="HolterRequestContentChange">
    <div id="container">
      <holterNavi v-bind:pageid='"HolterRequestContentChange"'></holterNavi>
      <div class="labelTitle lable">ホルター心電図配送ｻｰﾋﾞｽ 受付内容変更</div>
      <!--検索条件 -->
      <div class="condition-area">
        <table class="conditionTable">
          <tr>
            <th>受付番号</th><td><input type="text" v-model="searchConditions.receiptNumber"/></td>
            <th>出荷予定日</th><td><input type="date" v-model="searchConditions.shippingDate"/></td>
            <th>送り状番号</th><td><input type="text" v-model="searchConditions.invoiceNumber"/></td>
            <th>ステータス</th><td><select v-model="searchConditions.status"><option v-for="status in statusList" :key="status.name" :value="status.name">{{status.name}}</option></select></td>
          </tr>
          <tr>
            <th>機種</th><td><select v-model="searchConditions.Holter"><option v-for="model in modelList" :value="model.value" :key="model.value">{{ model.label1 }}</option></select></td>
            <th>配送先</th><td><select v-model="searchConditions.shippingAddress"><option></option><option value="home">患者宅</option><option value="hospital">医療機関</option></select></td>
            <th>宛名</th><td><input type="text" v-model="searchConditions.receiverName"/></td>
          </tr>
        </table>
        <div class="searchButton-area">
          <b-button class="is-primary" @click="doSearch">検索</b-button>
        </div>
      </div>
      <!-- 検索結果 -->
      <div class="result-area">
        <div class="resultTable-area" v-if="hasResult">
          <b-table
              id="holterRequestContentChangeTable"
              :data="data"
              :paginated="isPaginated"
              per-page="100"
              pagination-position="both"
              default-sort="user.first_name"
              aria-next-label="Next page"
              aria-previous-label="Previous page"
              aria-page-label="Page"
              aria-current-label="Current page">
              <template slot-scope="props">
                <b-table-column field="receiptNumber" label="受付番号" width="130" sortable centered>
                  <span v-if="!props.row.compFlag">
                  <template v-for="(receiptNumber, index) in props.row.receiptNumber">
                    <router-link v-if="index < 2" :to="{name:'HolterDetailEdit', query:{receiptNumber:encodeURIComponent(props.row.receiptNumber)}, params:{searchConditions:searchConditions,holterJudgmentFlg:props.row.holterJudgmentFlg}}" :key="index" style="align-items: flex-end;"><a>{{receiptNumber}}</a><b-icon icon="lead-pencil" class="requestEdiitIcon"/></router-link>
                    <br v-if="index < 2" :key="index+'a'"/>
                    <span v-if="index==3" :key="index+'b'">･･･</span>
                  </template>
                  </span>
                  <span v-else>
                  <template v-for="(receiptNumber, index) in props.row.receiptNumber">
                    <span v-if="index < 2" :key="index+'c'">{{receiptNumber}}</span>
                    <br v-if="index < 2" :key="index+'d'"/>
                    <span v-if="index==3" :key="index+'e'">･･･</span>
                  </template>
                  </span>
                </b-table-column>
                <b-table-column field="units" label="台数" width="40" centered>
                  {{props.row.units}}
                </b-table-column>
                <b-table-column field="shippingDate" label="出荷予定日" width="90" sortable centered>
                  {{props.row.shippingDate }}
                </b-table-column>
                <b-table-column field="invoiceNumber" label="送り状番号" width="110" sortable centered>
                  {{props.row.invoiceNumber }}
                </b-table-column>
                <b-table-column field="paymentNumber" label="着払い番号" width="160" sortable centered>
                  {{props.row.paymentNumber }}
                </b-table-column>
                <b-table-column field="status" label="ステータス" width="80" sortable centered>
                  <span :class="getHstTagClass(props.row.status)">
                    {{getStatusName(props.row.status)}}
                  </span>
                </b-table-column>
                <b-table-column field="holter" label="機種" width="190" sortable >
                  <!-- {{props.row.Holter}} -->
                  <!-- TODO: STEP2:機種
                  -->
                  ePatch
                  <span v-if="props.row.depositMachineFlag" class="depo"/>
                </b-table-column>
                <b-table-column field="shippingAddress" label="配送先" width="80" centered>
                  {{props.row.shippingAddress }}
                </b-table-column>
                <b-table-column field="receiverName" label="配送先宛名" width="270" sortable >
                  {{props.row.receiverName }}
                </b-table-column>
                <b-table-column field="receiverAddress" label="配送先住所" width="570" sortable >
                  {{props.row.receiverAddress }}
                </b-table-column>
              </template>
          </b-table>
      　</div>
      </div>
    </div>
  </div>
</template>

<script>
import naviBar from "@/components/mock/philips/holter/HolterNaviBar";
import {choicesType} from "@/components/mock/base/const.js";

export default {
  name: "HolterRequestContentChange",
  methods: {
    doSearch: function(){
      var isSearchParam = false
      var keys = Object.keys(this.searchConditions)
      for(var i=0; i < keys.length; i++){
        if(this.searchConditions[keys[i]]){
          isSearchParam = true
          break;
        }
      }
      if(!isSearchParam){
        // 検索条件が１つも設定されていない場合
        this.showErrorMessage("検索条件が入力されていません。")
        return;
      }
      this.data = []
      this.hasResult = false;
      var excuteApi = this.getHolterReceptionContentsListPOST;
      var successCallBack = this.getHolterReceptionContentsListPOSTSuccess;
      var errorCallBack = this.getHolterReceptionContentsListPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getHolterReceptionContentsListPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.searchConditions));
      obj.shippingDate = obj.shippingDate ? obj.shippingDate.replace(/-/g, "/") : ""
      
      // obj.status = obj.status && obj.status.length!=0 ? JSON.parse(obj.status)
      if(obj.status){
        var target = this.statusList.find(val => val.name == obj.status)
        if(target){
          obj.status = target.code
        }
      }else{
        obj.status = [];
      }
      return client.apis.internalHolter.getHolterReceptionContentsListPOST({
        body:obj
      });
    },
    getHolterReceptionContentsListPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
      if(this.data.length > 0){
        this.hasResult = true;
      }
    },
    getHolterReceptionContentsListPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    getStatusName: function(code) {
      var target = this.statusList.find(val => val.code && val.code.includes(code))
      if(target){
        return target.name
      }
      return ""
    }
  },
  data() {
    var takeOverSearchParams = this.$route.params["searchConditions"];
    var statusList = [
      {},
      {name:"未出荷",code:[1,2,3,21]},
      {name:"出荷済み",code:[4,5,6,7,8,9,10,11,12,13,14,15,16,22,23]},
      {name:"キャンセル",code:[17,24,25]}
    ]
    var modelList = this.getChoiceList(choicesType.holterKind, false);
    modelList.unshift({})
    return {
      searchConditions:{
        receiptNumber:"",
        shippingDate:"",
        invoiceNumber:"",
        status:"",
        Holter:"",
        shippingAddress:"",
        receiverName:""
      },
      data : [],
      isPaginated : true,
      hasResult:false,
      takeOverSearchParams,
      statusList,
      modelList
    };
  },
  async mounted() {
    if(this.takeOverSearchParams){
      this.searchConditions = this.takeOverSearchParams
      this.doSearch()
    }
  },
  filters: {},
  components: {
    holterNavi: naviBar
  },
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
input {
  width: 200px;
}
.tag {
  width :100px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/holter/HolterRequestContentChange.vue